module.exports = __webpack_public_path__ + "img/subject_03_106.jpg";